import React from 'react';
import { Modal } from 'react-responsive-modal';
import FormControl from '@mui/material/FormControl';
import MainButton from '../MainButton';
import { useStyles } from './styles';
import { useSelector, useDispatch } from 'react-redux';
import { handleToggleCityChangeModalAlert, handleToggleCityChangeAlert} from '../../redux/actions/elogisticaActions';
import {RootState} from '../../redux/reducers/index'
import { Close } from "../MainModal/Close";
import 'react-responsive-modal/styles.css';
import { language } from '../../utils/language';


export const CityChangeAlert = (props:any) => {

    const elogisticaState: any = useSelector((state: RootState) => state.elogistica);
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    const dispatch = useDispatch();

    const classes = useStyles(props);

    const onCloseModal = () => {
      dispatch(handleToggleCityChangeModalAlert());
      if (elogisticaState.CityChangeAlert) {
        
      } else {
        dispatch(handleToggleCityChangeAlert());
      }
      
    }

    return(
        <div>
            <Modal
                open={elogisticaState.CityChangeModalAlert}
                onClose={onCloseModal}
                closeIcon={<Close onClick={()=>{}} color={props.color} />}
                classNames={{
                  modal: classes.modal,
                }}
            >
              <p className={classes.title}>{language[homeState.default_language]["optionSend"]}</p>
                <p className={classes.content}>
                    {language[homeState.default_language]["messageCityChange"]}
                </p>
                <FormControl className={classes.buttons} style={{marginLeft: '1%' }}>
                  <MainButton
                    color={props.color}
                    type="button"
                    onClick={
                      () => onCloseModal()
                    }
                  >
                    {language[homeState.default_language]["ok"]}
                  </MainButton>
                </FormControl>
            </Modal>
        </div>
    )

}